export default __webpack_public_path__ + "static/extra-curricular-logo-dark-66ef4dee3082d59081308103a1675d6c.png";